/**
 * @owner @Appboy/whats-app
 */
import { z } from "zod";
import { whatsAppResponseCarouselSchema } from "@schemas/message/whatsAppResponseCarouselSchema";
import { whatsAppResponseMessageCommonSchema } from "@schemas/message/whatsAppResponseMessageCommonSchema";

// refer to WhatsAppResponseMessageCarouselExport
export const whatsAppResponseCarouselMessageSchema = z.object({
  ...whatsAppResponseMessageCommonSchema.shape,
  layout: z.literal("carousel"),
  // Keep required (not optional) to match WhatsAppResponseMessageCarouselExport: dropping .optional()
  // here would widen the *shared* `body` key across the composer's intersected layout types.
  body: z.string().nullable(),
  carousel: whatsAppResponseCarouselSchema,
});
